import React, { useEffect, useState } from "react";
import { 
  Typography, 
  Card, 
  Button, 
  DatePicker, 
  Select, 
  Table,
  Divider, 
  Space, 
  Row, 
  Col, 
  message,
  Modal,
  Input,
} from "antd";
import { DownloadOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import PDFDownloader from "../../../Components/PDFDownloader/PDFDownloader";
import AxiosCaller from "../../../authenticatie/AxiosCaller";
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;


const VoorstelGeschiedenisScreen = () => {
  const { get, post, put } = AxiosCaller();
  const [geschiedenis, setGeschiedenis] = useState([]);
  const [datum, setDatum] = useState(null);
  const [leerkracht, setLeerkracht] = useState(null);
  const [klas, setKlas] = useState(null);
  const [klassen, setKlassen] = useState([]);
  const [leerkrachten, setLeerkrachten] = useState([]);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);

  const [maxHeight, setMaxHeight] = useState(0);

  const [pdfModalVisible, setPdfModalVisible] = useState(false);
const [selectedVoorstel, setSelectedVoorstel] = useState(null);
const [bestandsnaam, setBestandsnaam] = useState('');
const [opmerkingPdf, setOpmerkingPdf] = useState('');
    
  useEffect(() => {
    const updateHeight = () => {
      setMaxHeight(0.7 * document.documentElement.clientHeight);
    };

    updateHeight(); // Initialiseren bij eerste render
    window.addEventListener("resize", updateHeight); // Updaten bij schermresizing

    return () => window.removeEventListener("resize", updateHeight); // Cleanup
  }, []);

  useEffect(() => {
    fetchVoorstelGeschiedenis();
    fetchKlasses();
    fetchLeerkrachten();
  }, []);
  
  useEffect(() => {
    fetchVoorstelGeschiedenis();
  }, [datum, leerkracht, klas]);

 const fetchVoorstelGeschiedenis = async () => {
  try {
    let date = null;

    if (datum) {
      date = dayjs(datum).format('YYYY-MM-DD'); // Zet datum om naar 'YYYY-MM-DD' formaat
    }
    
    const response = await post('/kookGeschiedenis/filtered', { 
      datum: date, 
      leerkracht: leerkracht, 
      klas: klas 
    });

    const response2 = await post('/voorstel/getGevalideerdFilterd', {
      datum: date,
      leerkracht: leerkracht,
      klas: klas
    })
    
    
    if (Array.isArray(response.data) && Array.isArray(response2.data)) {
        const combinedData = [...response.data, ...response2.data];
        
        // Sort by kookDatum (newest first)
        const sortedData = combinedData.sort((a, b) => {
          const dateA = new Date(a.kookDatum);
          const dateB = new Date(b.kookDatum);
          return dateB - dateA; // For newest first (descending)
        });
        
        setGeschiedenis(sortedData);
        console.log(sortedData);
      } else {
      console.error("API returned non-array data:", response.data);
      setGeschiedenis([]);
      openNotificationError("Foute data opgehaalt")
    }
  } catch (error) {
    console.error(error);
    openNotificationError("Fout bij ophalen van de geschiedenis", error)
  }
};

  const fetchKlasses = async () => {
    try {
      const response = await get('/klas');
      setKlassen(response.data);
    } catch (error) {
      console.error(error);
     openNotificationError("Fout bij ophalen van klassen", error)
    }
  };

  const fetchLeerkrachten = async () => {
    try {
      const response = await get('/users/exclude-aanvrager');
      setLeerkrachten(response.data);
    } catch (error) {
      console.error("Failed to fetch users: " + error);
      openNotificationError("Fout bij ophalen van de geberuikers", error)
    }
  };

  const handleLogistiekBlad = async (voorstel) => {
  try {
    const response = await get(`/kookGeschiedenis/logistiek/${voorstel._id}`);

    setSelectedVoorstel({ ...response.data, originalVoorstel: voorstel });
    setBestandsnaam(generateDefaultFilename(voorstel));
    setOpmerkingPdf(voorstel.opmerkingPdf || '');
    setPdfModalVisible(true);
    
     
  } catch (error) {
    if(error.response.status == 404){
      try{
        const response = await get(`/voorstel/logistiek/${voorstel._id}`);
        // Open modal for filename input
        setSelectedVoorstel({ ...response.data, originalVoorstel: voorstel });
        setBestandsnaam(generateDefaultFilename(voorstel));
        setOpmerkingPdf(voorstel.opmerkingPdf || '');
        setPdfModalVisible(true);
        
      } catch (error) {
        console.error(error);
        openNotificationError("Fout bij het generenen van de PDF", error)
      }
    } else {
      console.error(error);
      openNotificationError("Fout bij het generenen van de PDF", error)
    }
  }
};

const generateDefaultFilename = (voorstel) => {
  const date = dayjs(voorstel.kookDatum).format('DD-MM-YYYY');
  const klas = voorstel.klas.replace(/\s+/g, '_');
  return `Logistiek_${klas}_${date}`;
};

const handlePdfGeneration = async () => {
  if (!bestandsnaam.trim()) {
    message.error('Voer een bestandsnaam in');
    return;
  }

  if (selectedVoorstel) {
    try {
      // Generate PDF first
      PDFDownloader.generateLogistiekPDF(
        { 
          ...selectedVoorstel, 
          opmerking: opmerkingPdf.trim() 
        }, 
        bestandsnaam
      );

      // Only save the opmerking to the database if it's different from the original
      const originalOpmerking = selectedVoorstel.originalVoorstel?.opmerkingPdf || '';
      if (opmerkingPdf.trim() !== originalOpmerking.trim()) {
        const updateData = {
          opmerkingPdf: opmerkingPdf.trim()
        };

        try {
          await put(`/kookGeschiedenis/${selectedVoorstel.originalVoorstel._id}`, updateData);
          message.success('PDF gegenereerd en opmerking opgeslagen!');
        } catch (error) {
          if (error.response?.status === 404) {
            try {
              await put(`/voorstel/${selectedVoorstel.originalVoorstel._id}`, updateData);
              message.success('PDF gegenereerd en opmerking opgeslagen!');
            } catch (innerError) {
              console.error('Error saving opmerking to voorstel:', innerError);
              openNotificationError('PDF gegenereerd maar fout bij opslaan opmerking', innerError);
            }
          } else {
            console.error('Error saving opmerking to kookGeschiedenis:', error);
            openNotificationError('PDF gegenereerd maar fout bij opslaan opmerking', error);
          }
        }
      } else {
        message.success('PDF gegenereerd!');
      }
      
    } catch (pdfError) {
      console.error('Error generating PDF:', pdfError);
      openNotificationError('Fout bij het genereren van de PDF', pdfError);
    } finally {
      setPdfModalVisible(false);
      setBestandsnaam('');
      setOpmerkingPdf('');
      setSelectedVoorstel(null);
      fetchVoorstelGeschiedenis();
    }
  }
};
      
      
      
    


const handlePdfModalCancel = () => {
  setPdfModalVisible(false);
  setBestandsnaam('');
  setOpmerkingPdf('');
  setSelectedVoorstel(null);
};

const handleAllLogistiekBlad = async () => {
  // For multiple PDFs, you might want to generate them with a loop
  // or create a zip file. For now, we'll generate them sequentially
  for (const voorstel of geschiedenis) {
    await handleLogistiekBlad(voorstel);
    // Add a small delay between PDF generations
    await new Promise(resolve => setTimeout(resolve, 1000));
  }
};

  const toggleCard = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };

  

  return (
    <div className="Screen-container">
      
    {/* PDF Filename Modal */}
    <Modal
      title="Logistiek Blad Details"
      open={pdfModalVisible}
      onOk={handlePdfGeneration}
      onCancel={handlePdfModalCancel}
      okText="PDF Genereren"
      cancelText="Annuleren"
      centered
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <Text strong>Bestandsnaam voor PDF:</Text>
          <Input
            placeholder="Bestandsnaam"
            value={bestandsnaam}
            onChange={(e) => setBestandsnaam(e.target.value)}
            onPressEnter={handlePdfGeneration}
            suffix=".pdf"
            style={{ marginTop: '8px' }}
          />
          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
            De bestandsnaam wordt automatisch aangevuld met .pdf
          </Text>
        </div>
        
        <div>
          <Text strong>Opmerking (optioneel):</Text>
          <TextArea
            placeholder="Voeg een opmerking toe aan het logistiek blad..."
            value={opmerkingPdf}
            onChange={(e) => setOpmerkingPdf(e.target.value)}
            rows={4}
            style={{ marginTop: '8px' }}
            maxLength={500}
          />
          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
            {opmerkingPdf.length}/500 karakters
          </Text>
        </div>

        {selectedVoorstel && (
          <div style={{ background: '#f5f5f5', padding: '12px', borderRadius: '6px' }}>
            <Text strong>Logistiek blad overzicht:</Text>
            <div style={{ marginTop: '8px' }}>
              <Text type="secondary">Klas: </Text>
              <Text>{selectedVoorstel.klas}</Text>
            </div>
            <div>
              <Text type="secondary">Leerkracht: </Text>
              <Text>{selectedVoorstel.leerkracht}</Text>
            </div>
            <div>
              <Text type="secondary">Datum: </Text>
              <Text>{dayjs(selectedVoorstel.datum).format('DD/MM/YYYY')}</Text>
            </div>
            <div>
              <Text type="secondary">Aantal producten: </Text>
              <Text>{selectedVoorstel.producten?.length || 0}</Text>
            </div>
          </div>
        )}
      </Space>
    </Modal>
      <div className="space-between">
      <h1 className='title'>Kookgeschiedenis</h1>
      <Button 
            type="primary" 
            icon={<DownloadOutlined />}
            onClick={() => handleAllLogistiekBlad()}
            disabled={!datum || geschiedenis.length === 0}
          >
            Download All logisiteke bladen
          </Button>
      </div>

      <FilterContainer
        datum={datum}
        setDatum={setDatum}
        klassen={klassen}
        klas={klas}
        setKlas={setKlas}
        leerkrachten={leerkrachten}
        leerkracht={leerkracht}
        setLeerkracht={setLeerkracht}
      />

      {geschiedenis.length > 0 ? (
        <Space
          direction="vertical"
          size="middle"
          style={{ width: '100%', overflowY: "auto", maxHeight, marginTop: '16px' }}
        >
          {geschiedenis.map((item, index) => (
            <Voorstel
              key={index}
              voorstel={item}
              isExpanded={expandedCardIndex === index}
              onClick={() => toggleCard(index)}
              handleLogistiekBlad={handleLogistiekBlad}
            />
          ))}
        </Space>
      ) : (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px', 
          backgroundColor: '#f0f0f0', 
          borderRadius: '8px' 
      }}>
          Geen geschiedenis gevonden
      </div>
      )}


      
    </div>
  );
};

const FilterContainer = ({ datum, setDatum, klassen, klas, setKlas, leerkrachten, leerkracht, setLeerkracht }) => {
  return (

      <Row gutter={24}>
        <Col span={8}>
          <DatePicker
            style={{ width: '100%' }}
            value={datum ? dayjs(datum) : null}
            onChange={(date) => setDatum(date ? date.format('YYYY-MM-DD') : null)}
            placeholder="Selecteer datum"
            format="DD/MM/YYYY"
          />
        </Col>
        <Col span={8}>
          <Select
            style={{ width: '100%' }}
            value={klas}
            onChange={(value) => setKlas(value)}
            placeholder="Selecteer klas"
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {klassen.map((item, index) => (
              <Option key={index} value={item.naam}>
                {item.naam}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={8}>
          <Select
            style={{ width: '100%' }}
            value={leerkracht}
            onChange={(value) => setLeerkracht(value)}
            placeholder="Selecteer leerkracht"
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {leerkrachten.map((item, index) => (
              <Option key={index} value={item.naam}>
                {item.naam}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
  );
};

const Voorstel = ({ voorstel, isExpanded, onClick, handleLogistiekBlad }) => {
  const getProductColumns = () => {
    return [
      {
        title: 'Product',
        dataIndex: 'product',
        key: 'product',
      },
      {
        title: 'Aantal',
        key: 'aantalEenheid',
        align: 'right',
        render: (_, record) => `${record.aantal.toFixed(1)} ${record.eenheid}`
      }
    ];
  };

  // Modified to use the voorstel prop directly
  const getAllProducts = () => {
    const products = [];
    
    // Process voorgerecht (appetizer)
    if (voorstel.voorgerecht && voorstel.voorgerecht.producten) {
      voorstel.voorgerecht.producten.forEach(product => {
        products.push({
          ...product,
          categorie: "Voorgerecht",
          gerecht: voorstel.voorgerecht.naam || ""
        });
      });
    }
    
    // Process hoofdgerecht (main course)
    if (voorstel.hoofdgerecht && voorstel.hoofdgerecht.producten) {
      voorstel.hoofdgerecht.producten.forEach(product => {
        products.push({
          ...product,
          categorie: "Hoofdgerecht",
          gerecht: voorstel.hoofdgerecht.naam || ""
        });
      });
    }
    
    // Process nagerecht (dessert)
    if (voorstel.nagerecht && voorstel.nagerecht.producten) {
      voorstel.nagerecht.producten.forEach(product => {
        products.push({
          ...product,
          categorie: "Nagerecht",
          gerecht: voorstel.nagerecht.naam || ""
        });
      });
    }
    
    return products;
  };

  const productColumns = [
    ...getProductColumns()
  ];

  return (
    <Card 
      style={{ width: '100%' }}
      bodyStyle={{ padding: isExpanded ? '16px' : '12px 16px' }}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <Space direction="vertical" size="small">
            <Space>
              <Text strong>Kook datum:</Text>
              <Text>{dayjs(voorstel.kookDatum).format('DD/MM/YYYY')}</Text>
            </Space>
            <Space>
              <Text strong>Klas:</Text>
              <Text>{voorstel.klas}</Text>
            </Space>
            <Space>
              <Text strong>Leerkracht:</Text>
              <Text>{voorstel.leerkracht}</Text>
            </Space>
            <Space>
              <Text strong>Aantal:</Text>
              <Text>{voorstel.aantalStudenten} leerlingen</Text>
            </Space>
            <Space>
              <Text strong>Gerechten</Text>
              <Text>
                {[
                  voorstel.voorgerecht?.naam,
                  voorstel.hoofdgerecht?.naam,
                  voorstel.nagerecht?.naam
                ].filter(Boolean).join(", ")}
              </Text>
            </Space>

          </Space>
        </Col>
        
        <Col>
          <Button 
            type="primary" 
            icon={<DownloadOutlined />}
            onClick={() => handleLogistiekBlad(voorstel)}
          >
            Download Logistiek Blad
          </Button>
        </Col>
      </Row>
      
      {voorstel.opmerkingPdf && (
        <div style={{ marginTop: '8px' }}>
          <Text strong>Opmerking:</Text> {voorstel.opmerkingPdf}
        </div>
      )}
      
      {isExpanded && (
        <div style={{ marginTop: '16px' }}>
          <Table 
            style={{ width: '100%' }}
            dataSource={getAllProducts()} 
            columns={productColumns}
            rowKey={(record, index) => index}
            pagination={false}
            size="middle"
            bordered
            locale={{ emptyText: 'Geen producten gevonden voor dit voorstel.' }}
          />
        </div>
      )}
      
      <Divider style={{ margin: '8px 0' }} />
      
      <div 
        style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          cursor: 'pointer',
          color: '#1890ff'
        }}
        onClick={onClick}
      >
        {!isExpanded ? (
          <Space>
            <Text>Meer info</Text>
            <DownOutlined />
          </Space>
        ) : (
          <Space>
            <Text>Minder info</Text>
            <UpOutlined />
          </Space>
        )}
      </div>
    </Card>
  );
};

export default VoorstelGeschiedenisScreen;